// extracted by mini-css-extract-plugin
export default {"root":"KEIyL","mobileLayout":"Qqu82","card":"Zpcep","onShader":"QWWmT"};